<div class="hbox-nowrap breadcrumb">
  <div class="hbox-nowrap" *ngFor="let p of path; let i = index">
    <div *ngIf="i > 0"> / </div> <div>{{p.title}}</div>
  </div>
</div>
